import { useQuery } from '@tanstack/react-query';
import { useLocale } from 'next-intl';
import { anglesGuideService } from '../api/angles-guide';

/**
 * Fetches the localized "Tips for great source angles" help copy from the API.
 * The locale is part of the query key so an in-app language switch refetches the
 * right translation. Copy is static, so it caches for a long time.
 */
export function useProjectAnglesGuide() {
  const locale = useLocale();
  return useQuery({
    queryKey: ['content', 'project-angles-guide', locale],
    queryFn: () => anglesGuideService.get(),
    staleTime: 1000 * 60 * 60, // 1h — static localized copy
  });
}
